import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

// Post-signup onboarding. The index route owns the first-install flow (terms,
// attribution, product); per-product children render product-specific setup.
export const welcomeRoutes: PermissionedRouteObject[] = [
  {
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { WelcomePage } = await import("./welcome-page");
          return { Component: WelcomePage };
        },
      },
      {
        path: "chargebacks",
        async lazy() {
          const { ChargebacksWelcomePage } =
            await import("./chargebacks/chargebacks-welcome-page");
          return { Component: ChargebacksWelcomePage };
        },
      },
    ],
  },
];
